// storybook-check-ignore
import React from 'react';

import { Link, Text } from '@opendoor/bricks/core';
import { motion } from 'framer-motion';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  variants?: any;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  showOnTablet,
  tabletDisplay,
  variants,
}) => {
  const displayValue = showOnTablet ? (['flex', null, tabletDisplay, 'none'] as any) : undefined;

  return (
    <Text
      as={motion.li}
      mb="32px"
      size="160"
      fontWeight="medium"
      display={displayValue}
      variants={variants}
    >
      <Link
        aria-current={isActive}
        href={href}
        aria-label="View link"
        analyticsName={analyticsName}
        alignItems="center"
        color="neutrals100"
        display="inline-flex"
        lineHeight="100"
        fontWeight="medium"
      >
        {name}
      </Link>
    </Text>
  );
};
